<template>
  <div v-if="hasErrors" class="error-messages">
    <ul>
      <li v-for="error in errors" :key="error.code">
        {{ error.message }}
      </li>
    </ul>
  </div>
  <form class="form" @submit.prevent="handleFormSubmit">
    <label class="field">
      <div class="input">
        <input
          v-model.trim="email"
          type="email"
          class="input__element"
          autocomplete="email"
          placeholder="E-mail address"
        />
        <div v-if="v$.email.$dirty" class="input__response">
          <ul>
            <li v-for="error of v$.email.$errors" :key="error.$uid">
              {{ error.$message }}
            </li>
          </ul>
        </div>
      </div>
    </label>
    <label class="field">
      <div class="input">
        <input
          v-model.trim="password"
          type="password"
          class="input__element"
          autocomplete="current-password"
          placeholder="Password"
        />
        <div v-if="v$.password.$dirty" class="input__response">
          <ul>
            <li v-for="error of v$.password.$errors" :key="error.$uid">
              {{ error.$message }}
            </li>
          </ul>
        </div>
      </div>
    </label>
    <div class="field">
      <Button type="submit" full-width :loading="loading"
        >Sign in with email</Button
      >
    </div>
  </form>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { required, email } from "@vuelidate/validators";
import { mapActions } from "vuex";
import isEmpty from "lodash-es/isEmpty";
import Button from "@/components/Button.vue";

export default {
  name: "LoginForm",
  components: {
    Button,
  },
  emits: ["success"],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      email: "",
      password: "",
      errors: [],
      loading: false,
    };
  },
  computed: {
    hasErrors() {
      return this.errors.length > 0;
    },
  },
  methods: {
    ...mapActions("auth", ["attemptLogin"]),
    async handleFormSubmit() {
      this.v$.$touch();

      if (this.v$.$invalid) {
        return;
      }
      const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      });

      const returnUrl = params["checkout_url"] || params["return_url"];
      const loginObj = {
        email: this.email,
        password: this.password,
      };

      if (returnUrl) {
        loginObj.returnUrl = returnUrl;
      }

      this.loading = true;
      const { customerAccessToken, customerUserErrors } =
        await this.attemptLogin(loginObj);

      if (customerUserErrors) {
        this.errors = customerUserErrors;
      }

      if (!isEmpty(customerAccessToken)) {
        this.$emit("success");
      }
      this.loading = false;
    },
  },
  validations() {
    return {
      email: { required, email },
      password: { required },
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/components/form.scss";

.error-messages {
  margin-top: 10px;
  margin-bottom: 10px;
  background-color: $color-red;
  padding: 16px;
  color: $color-white;
  border-radius: 2px;
}
</style>
